'use client';

import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { Button } from '@/components/ui/button';
import { MessageSquare, X } from 'lucide-react';
import { Skeleton } from '../ui/skeleton';

// Dynamically import the main chatbot component with SSR disabled to prevent hydration issues
const ChatbotPanel = dynamic(() => import('@/components/shared/chatbot').then(mod => mod.Chatbot), {
    loading: () => (
        <div className="fixed bottom-24 right-4 z-50 w-full max-w-sm">
            <Skeleton className="h-[540px] w-full rounded-lg" />
        </div>
    ),
    ssr: false
});

export function ClientChatbot() {
    const [isOpen, setIsOpen] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        const handleOpenChat = () => {
            setIsOpen(true);
        };
        window.addEventListener('open-upbot', handleOpenChat);
        return () => window.removeEventListener('open-upbot', handleOpenChat);
    }, []);

    if (!mounted) return null;

    return (
        <>
            <div className="fixed bottom-4 right-4 z-50">
                <Button 
                    id="chatbot-trigger"
                    size="icon" 
                    variant="accent" 
                    className="rounded-full w-16 h-16 shadow-lg transition-transform duration-300 hover:scale-110" 
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <X className="h-8 w-8" /> : <MessageSquare className="h-8 w-8" />}
                    <span className="sr-only">Toggle Chatbot</span>
                </Button>
            </div>

            {isOpen && <ChatbotPanel />}
        </>
    );
}
